<template>
    <div :class="$style.place">
        <a :href="href" class="color-inherit">
            <h2 :class="$style.placeName" v-text="name" />
        </a>

        <div :class="$style.placeAddress" v-text="address" />

        <div v-if="sponsored">
            <span :class="$style.sponsored">
                {{ $t('place.sponsored') }}
            </span>
        </div>

        <ThatsupGallery
            v-if="images?.length"
            :images="images"
            :class="$style.placeImage"
        ></ThatsupGallery>

        <strong v-if="title && title !== name" :class="$style.placeTitle" v-text="title"></strong>

        <div
            v-if="website || instagramUrl || (buttons && buttons.length)"
            class="tw-mb-4 tw-mt-4 tw-flex tw-flex-wrap tw-gap-1"
        >
            <a
                v-if="website"
                class="referral-page tctrack article-list__element__button"
                target="_blank"
                rel="noopener"
                :title="website"
                :href="website"
                :data-track="getTrackingValue('Website referrals')"
            >
                <i class="sli sli-x18 sli-network-refresh mr-1"></i>
                {{ $t('place.website_label') }}
            </a>
            <a
                v-if="instagramUrl"
                class="tctrack article-list__element__button !tw-px-2.5"
                target="_blank"
                rel="noopener"
                :title="instagramUrl"
                :href="instagramUrl"
                :data-track="getTrackingValue('Instagram referrals')"
            >
                <i class="sli sli-x20 sli-instagram"></i>
            </a>
            <a
                v-if="buttons"
                v-for="button in buttons"
                class="referral-page tctrack article-list__element__button"
                target="_blank"
                rel="noopener"
                :href="button.url"
                :data-track="getTrackingValue('custom_referral')"
            >
                <i class="sli sli-x18 sli-network-refresh mr-1"></i>
                {{ button.title }}
            </a>
        </div>
        <strong :class="$style.placeSubtitle" v-text="subTitle"></strong>

        <div :class="$style.placeBodyText" v-html="body"></div>

        <ul v-if="infoRows?.length || website" :class="$style.infoRows">
            <li v-for="row in infoRows || []" :class="$style.infoRow">
                <strong v-html="row.title.trim().replace(/:$/, '') + ':'"></strong>
                &nbsp;
                <span v-html="row.value"></span>
            </li>
        </ul>
    </div>
</template>

<script setup>
import ThatsupGallery from '../../Shared/components/ThatsupGallery.vue'

const props = defineProps({
    id: [String, Number],
    name: String,
    address: String,
    title: String,
    subTitle: String,
    body: String,
    href: String,
    images: Array,
    infoRows: Array,
    sponsored: Boolean,
    website: String,
    instagramUrl: String,
    buttons: Array,
})

const getTrackingValue = (event, properties = {}) => {
    return JSON.stringify(getTrackingProperties(event, properties))
}
const getTrackingProperties = (event, properties = {}) => {
    return [
        event,
        {
            category: 'Place',
            label: props.name,
            place: props.id,
            ...properties,
        },
    ]
}
</script>

<style module>
.place {
    padding: 27px;
    overflow: auto;
}

.placeName {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 0;
    display: inline-block;
}

.placeAddress {
    font-size: 16px;
    margin-bottom: 6px;
}

.placeImage {
    margin-top: 22px;
    margin-bottom: 22px;
    border-radius: 6px;
    max-width: 100%;
    height: auto;
}

.placeTitle {
    font-weight: 700;
    font-size: 1.25em;
    display: block;
}
.placeSubtitle {
    font-weight: 600;
    display: block;
}

.placeBodyText {
    margin-top: 8px;
}

.infoRows {
    margin-top: 20px;
    line-height: 1.75em;
}

.infoRow {
}

.sponsored {
    font-size: 11px;
    text-transform: uppercase;
    font-weight: bold;
    letter-spacing: 1px;
    padding: 3px 6px 4px 6px;
    background-color: #f2f2f2;
    border: 1px solid #e7e7e7;
    color: #757575;
    display: inline-block;
    border-radius: 4px;
    margin-top: 5px;
}
</style>
